import { render, staticRenderFns } from "./owner.vue?vue&type=template&id=b73cfc58&scoped=true&"
import script from "./owner.vue?vue&type=script&lang=js&"
export * from "./owner.vue?vue&type=script&lang=js&"
import style0 from "./owner.vue?vue&type=style&index=0&id=b73cfc58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73cfc58",
  null
  
)

component.options.__file = "owner.vue"
export default component.exports